// extracted by mini-css-extract-plugin
export default {"styledCheckbox":"StyledCheckbox_styledCheckbox__S+E0A"};